"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OffNetworkCarrierScac = void 0;
// We should store these as lowercase
var OffNetworkCarrierScac;
(function (OffNetworkCarrierScac) {
    OffNetworkCarrierScac["ABFFreight"] = "abf";
    OffNetworkCarrierScac["ABFFreightP44"] = "abfs";
    OffNetworkCarrierScac["CentralFreight"] = "cenf";
    OffNetworkCarrierScac["ClearLaneFreight"] = "clni";
    OffNetworkCarrierScac["Conway"] = "cnwy";
    OffNetworkCarrierScac["CustomCompanies"] = "ctbv";
    OffNetworkCarrierScac["FrontlineFreight"] = "fcsy";
    OffNetworkCarrierScac["OldDominion"] = "odfl";
    OffNetworkCarrierScac["Mothership"] = "mhpg";
    OffNetworkCarrierScac["Reddaway"] = "retl";
    OffNetworkCarrierScac["Roadrunner"] = "rdfs";
    OffNetworkCarrierScac["SAIA"] = "saia";
    OffNetworkCarrierScac["Southeastern"] = "sefl";
    /** This is also the SCAC for TForce Freight */
    OffNetworkCarrierScac["UPSFreight"] = "upgf";
    OffNetworkCarrierScac["Ward"] = "ward";
    OffNetworkCarrierScac["XPOLogistics"] = "cnwy";
    OffNetworkCarrierScac["XPOLogisticsP44"] = "xpol";
    OffNetworkCarrierScac["YRCFreight"] = "rdwy";
})(OffNetworkCarrierScac = exports.OffNetworkCarrierScac || (exports.OffNetworkCarrierScac = {}));
//# sourceMappingURL=offNetworkCarrierInfo.js.map